import React from 'react'
import { Button, Modal } from 'react-bootstrap'

function DeleteModal(props) {
    const { show, confirmDelete, handleCloseModal, text, confirmText, cancelText, body } = props
    return (
        <Modal size="md" show={show} centered>
            <Modal.Body className="p-5">
                <React.Fragment>
                    <div className="modal-body text-center p-4">
                        <i className="fe fe-alert-circle fs-65 text-danger lh-1 mb-4 d-inline-block"></i>
                        <h3>
                            {text || 'Are you sure?'}
                        </h3>
                        {typeof body !== 'undefined' && typeof body !== 'string' ? body : <p className='text-muted'>{body}</p>}
                        <div style={{ marginTop: 20 }}>
                        <Button type="submit" variant="primary" className="me-2" onClick={confirmDelete}> {confirmText || 'Yes, delete it!'} </Button>
                        <Button type="button" variant="secondary" onClick={handleCloseModal}> {cancelText || 'Cancel'} </Button>
                        </div>
                    </div>
                </React.Fragment>
            </Modal.Body>
        </Modal>
    )
}

export default DeleteModal;